// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

import { useEffect, useState } from 'react';
import { licenseService, type LicenseSummary } from '@/api/licenseService';
import { bostaYukle } from '@/lib/bostaYukle';

interface LicenseStatus {
  loading: boolean;
  license: LicenseSummary | null;
  daysUntilExpiry: number | null;
  isExpiringSoon: boolean;
  isExpired: boolean;
  isReadonly: boolean;
  isSuspended: boolean;
  /** Lisans on-premise paketinde: veri müşterinin sunucusunda, bulut arayüzü bilgi sayfası gösterir. */
  isOnPremise: boolean;
}

export function useLicenseStatus(): LicenseStatus {
  const [license, setLicense] = useState<LicenseSummary | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Lisans özeti bir rozet/uyarı kaynağıdır; ilk ekranı bekletmemesi için boşta yüklenir.
    bostaYukle(() => {
      licenseService.getInfo().then((l) => {
        setLicense(l);
        setLoading(false);
      }).catch((e: unknown) => {
        // Hatayı tamamen yutmak, "lisansı olmayan hesap" ile "lisans servisi çöktü" durumlarını
        // birbirinden ayırt edilemez yapıyordu: süresi dolmak üzere olan müşteri hiçbir uyarı
        // görmeden bir sabah sistemin kapandığını fark ederdi. En azından iz bırak.
        console.warn('[lisans] Durum okunamadı — uyarı rozeti çizilemeyecek:', e);
        setLoading(false);
      });
    });
    // 5 dk ping
    const tid = setInterval(() => {
      licenseService.getInfo().then(setLicense).catch((e: unknown) => {
        console.warn('[lisans] Periyodik durum okunamadı:', e);
      });
    }, 5 * 60 * 1000);
    return () => clearInterval(tid);
  }, []);

  if (!license) {
    return {
      loading,
      license: null,
      daysUntilExpiry: null,
      isExpiringSoon: false,
      isExpired: false,
      isReadonly: false,
      isSuspended: false,
      isOnPremise: false,
    };
  }

  const expiry = new Date(license.expiryDate);
  const days = Math.floor((expiry.getTime() - Date.now()) / (1000 * 60 * 60 * 24));

  return {
    loading,
    license,
    daysUntilExpiry: days,
    isExpiringSoon: days <= 14 && days > 0,
    isExpired: days <= 0,
    isReadonly: license.isReadonly,
    isSuspended: license.isSuspended,
    isOnPremise: license.deploymentModel === 'onprem',
  };
}
